import React, { useEffect, useState } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import { getSlug } from "../../utils/utils";

import "./tenStories2AdWithLoadMore.m.css";
import DfpAd from "../../dfp-ad";

const TenStories2AdWithLoadMore = ({ collection, sections, domainSlug, publisherAttributes }) => {
  const [isMobile, setIsMobile] = useState(false);
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  const collectionSlug = getSlug(collection, sections, domainSlug);

  return (
    <div styleName="base" data-testid="ten-story-load-more">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collection.name}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="wrapper">
        <div styleName="empty-div" />
        <Organism1 collection={collection} captionStyle="default" />
        <div>
          <div styleName="ad-slot">
            <DfpAd adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_728x90_B2" : "Home_728x90_B2"} />
          </div>
        </div>
      </div>
    </div>
  );
};

TenStories2AdWithLoadMore.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(TenStories2AdWithLoadMore);
